import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'

export default function ConfirmationModal({ profileModal, handleClose, updateClinicianProfile }) {
  return (
    <Modal show={profileModal} onHide={() => handleClose()} backdrop={'static'}>
      <Modal.Header>
        <Modal.Title>Confirm Profile Updates</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please confirm your changes.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="light" style={{ color: 'white', background: 'rgba(0, 127, 97, 1)' }} onClick={updateClinicianProfile}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
